import { IResponse, PureRestRequest } from '@portals/fetch-api';
import { TSerializedEditorState } from '@portals/hc-rich-editor';
import { makeRequestConfig, TGetArticlesParams } from './make-request-config';

export const getArticleMaterialRequest = (
  params: TGetArticlesParams,
): Promise<IResponse<{ reachEditorState: TSerializedEditorState }>> =>
  new PureRestRequest().getRequest(makeRequestConfig(params));
